import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import ace from 'ace-builds/src-noconflict/ace';
import 'ace-builds/src-noconflict/mode-javascript';
import 'ace-builds/src-noconflict/mode-json';
import 'ace-builds/src-noconflict/theme-kuroir';
import 'ace-builds/src-noconflict/theme-terminal';
import AceEditor from 'react-ace';
import { Controller, useForm } from 'react-hook-form';
/*eslint-disable no-alert, no-console */
import 'ace-builds/src-min-noconflict/ext-language_tools';
import 'ace-builds/src-min-noconflict/ext-searchbox';

import CategoryIcon from '@mui/icons-material/Category';
import SaveIcon from '@mui/icons-material/Save';
import { Box, Button, TextField } from '@mui/material';
import Alert from '@mui/material/Alert';
// Vite replacement for webpack-resolver: resolve the syntax workers as asset URLs.
import jsWorkerUrl from 'ace-builds/src-noconflict/worker-javascript?url';
import jsonWorkerUrl from 'ace-builds/src-noconflict/worker-json?url';
ace.config.setModuleUrl('ace/mode/javascript_worker', jsWorkerUrl);
ace.config.setModuleUrl('ace/mode/json_worker', jsonWorkerUrl);

import useFormula from '../../hooks/Formula';
import { useStyles } from './styles';

const createRenderAceEditor =
  (mode, placeholder, name) =>
  ({ field }) => (
    <AceEditor
      mode={mode}
      theme="kuroir"
      width="100%"
      style={{ height: '100px' }}
      fontSize={16}
      showPrintMargin={false}
      showGutter={false}
      value={field.value}
      wrapEnabled
      placeholder={placeholder}
      highlightActiveLine
      onChange={field.onChange}
      name={name}
      setOptions={{
        useWorker: true,
        enableLiveAutocompletion: true,
        enableSnippets: true,
        showLineNumbers: false,
        tabSize: 2,
      }}
    />
  );

const renderFormulaEditor = createRenderAceEditor('javascript', 'Formula', 'formula');
const renderConfigEditor = createRenderAceEditor('json', 'Config (json)', 'config');
const renderDataEditor = createRenderAceEditor('json', 'Sample Data (json)', 'data');

const renderTypeField = ({ field }) => <TextField id="type" label="Type" {...field} />;
const renderOrderField = ({ field }) => <TextField type="number" id="order" label="Order" {...field} />;

export default function FormulaForm() {
  let history = useNavigate();
  const { id } = useParams();
  const { formulas, type, setType, formula, add, update, evaluate, value, evalError } = useFormula();

  const { control, handleSubmit, reset, getValues } = useForm();

  useEffect(() => {
    // console.log('reset formula...', formula);
    reset(formula);
  }, [formula]);

  const onSubmit = (data) => {
    const formulaData = data;
    formulaData.config = JSON.parse(data.config);
    formulaData.data = JSON.parse(data.data);

    if (id && formula) {
      update(id, formulaData);
    } else {
      add(formulaData).then((resp) => {
        if (resp.ok) {
          navigate(`/formulas/${resp.data.id}`);
        }
      });
    }
  };

  const testEvalulate = (e) => {
    const formulaData = getValues();
    formulaData.config = JSON.parse(formulaData.config);
    formulaData.data = JSON.parse(formulaData.data);

    evaluate(formulaData);
    // console.log('Value: ', value);
  };

  const { classes } = useStyles();

  return (
    <Box sx={{ margin: 5 }}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Controller name="formula" control={control} render={renderFormulaEditor} />

        <div className={classes.formLabel}>Type</div>
        <Controller name="type" defaultValue="" control={control} render={renderTypeField} />

        <div className={classes.formLabel}>Config</div>
        <Controller name="config" control={control} render={renderConfigEditor} />

        <div className={classes.formLabel}>Sample Data</div>
        <Controller name="data" control={control} render={renderDataEditor} />

        <div className={classes.formLabel}>Order</div>
        <Controller name="order" control={control} defaultValue={0} render={renderOrderField} />
        {value && (
          <Box sx={{ mt: 2 }}>
            <Alert variant="outlined" severity="info">
              {value.type} - {value.val}
            </Alert>
          </Box>
        )}
        {evalError && (
          <Box sx={{ mt: 2 }}>
            <Alert variant="outlined" severity="error">
              {evalError}
            </Alert>
          </Box>
        )}
        <Box sx={{ mt: 2 }}>
          <Button variant="contained" color="primary" size="small" type="submit" disabled={!value} startIcon={<SaveIcon />}>
            Save
          </Button>
          <Button variant="contained" color="secondary" className={classes.evaluateButton} size="small" onClick={testEvalulate} startIcon={<CategoryIcon />}>
            Evaluate
          </Button>
        </Box>
      </form>
    </Box>
  );
}
